// extracted by mini-css-extract-plugin
export var black = "_1c-6";
export var brand = "_1c-1";
export var ddefault = "_1c-0";
export var error = "_1c-3";
export var gray = "_1c-2";
export var highContrast = "_1c-8";
export var outline = "_1c-7";
export var success = "_1c-5";
export var warning = "_1c-4";